module.exports = __webpack_public_path__ + "img/003.0e8374bf.jpg";